import React from 'react';
import { Link } from 'react-router-dom';

// Import translation
import i18n from 'i18next';

export const createColumns = (handleSelectItem, isReadOnly) => [
	{
		Header: i18n.t('documents:table_columns.alias'),
		accessor: 'alias'
	},
	{
		Header: i18n.t('documents:table_columns.title'),
		accessor: 'title',
		Cell: ({
			row: {
				_original: { id, title }
			}
		}) => <Link to={`/panel/documents/edit/${id}/metadata`}>{title}</Link>
	},
	{
		Header: i18n.t('documents:table_columns.created_at'),
		accessor: 'created_at'
	},
	{
		Header: i18n.t('documents:table_columns.updated_at'),
		accessor: 'updated_at'
	},
	{
		Header: i18n.t('common:table_columns.delete'),
		accessor: 'delete',
		width: 60,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { id }
			}
		}) =>
			!isReadOnly && (
				<button
					onClick={() => handleSelectItem(id)}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-trash" />
				</button>
			)
	}
];
